import React from "react"
import { Row, Col, FormGroup,Panel,Button, FormControl  } from "react-bootstrap"
import { func, bool } from "prop-types"
//import { Link } from "react-router-dom";
//import { Field, reduxForm } from "redux-form";
import {  reduxForm } from "redux-form"
import { composeValidators, combineValidators, isRequired } from "revalidate"
import { connect } from "react-redux"
import { isValidEmail } from "utils/validation.js" // eslint-disable-line import/no-extraneous-dependencies
import { signinWithPassword } from "ducks/auth.js" // eslint-disable-line import/no-extraneous-dependencies
import logo from "../images/COLLEGIATE-300PXw.png"
import background  from "../images/background.jpg"
//import FormField from "../components/auth/FormField";
//import ContentWrapper from "../components/layout/ContentWrapper"
const verticalAlign = {
  position: 'relative',
  //top: '50%',
 // transform: 'translateY(-50%)',
  left:'30%'
}
 
const pageBackground = {
  backgroundImage: `url(${background})`,
	height:'100%',
	paddingTop:'10%'
}

const UserRegistration = ({ handleSubmit, submitting }) => (
 
  <div className='col-sm-12' style={pageBackground} >
    <Row className='col-sm-5' style={verticalAlign}>
      <Col>
          <Panel sm={6} >
           <div className="panel-heading text-center" style={{ paddingTop:'30px' }} >
              <img src={logo} alt="Image" className="img-rounded pull-left" style={{ marginTop:'-50px' }} /> <h3 style={{ color:'rgb(7,30,98)' }}>Complete your request</h3>
           </div> 
           <hr style={{ color:'rgb(7,30,98)' }}/>
            <form className="form-horizontal" sm={4}>
            <FormGroup>
                  <label className='col-sm-2 col-md-4 col-lg-3 control-label'>USBC Member ID</label>
                  <Col sm={4 }>
                    <FormControl type="text" placeholder='Prefix' className="form-control" autoFocus />
                  </Col>
								
                  <Col sm={4 }>
                    <FormControl type="text" placeholder='Suffix'  className="form-control" autoFocus />
                  </Col>
              </FormGroup>
              <FormGroup>
								<label className='col-sm-2 col-md-4 col-lg-3 control-label'>First Name</label>
								<Col sm={8 }>
									<FormControl type="text"  className="form-control" />
								</Col>
              </FormGroup>
              <FormGroup>
								<label className='col-sm-2 col-md-4 col-lg-3 control-label'>Last Name</label>
								<Col sm={8 }>
									<FormControl type="text"  className="form-control" />
								</Col>
              </FormGroup>
              <FormGroup>
								<label className='col-sm-2 col-md-4 col-lg-3 control-label'>Email</label>
								<Col sm={8 }>
									<FormControl type="email"  className="form-control" />
								</Col>
            
                    <Col smOffset={3} sm={8 }>
                        <Button  style={{ backgroundColor:'rgb(7,30,98)', color:'white', marginTop:'15px' }}   onClick={handleSubmit} disabled={submitting}><h4>&nbsp;&nbsp;&nbsp;&nbsp;Request Collegiate Tournament Portal Access&nbsp;&nbsp;&nbsp;&nbsp;</h4></Button>{' '}
                    </Col>
              </FormGroup>
                 
          </form>
          </Panel>
          </Col>
					<footer style={{ paddingLeft:'20%' }}>
							<span style={{ color:'white' }}>&copy; 2017 - United States Bowling Congress. All rights reserved.</span>
						
						</footer>
          </Row>
				
  </div>

)
  
  // <div className="block-center mt-xl  wd-xxl" >
  //   <div className="panel panel-default panel-flat">
  //     <div className="panel-heading text-center">
  //       <img src={logo} alt="Image" className="block-center img-rounded" />
  //     </div>
  //     <div className="panel-body">
  //       <p className="text-center pv">COMPLETE USER REGISTRATION.</p>
  //       <form className="mb-lg" onSubmit={handleSubmit}>
  //       First Name: <Field
  //           component={FormField}
  //           name="firstname"
  //           type="text"
  //           placeholder="Enter your firstname"
            
  //         />
  //          <Field
  //           component={FormField}
  //           name="firstname"
  //           type="text"
  //           placeholder="Enter your firstname"
            
  //         />
  //          <Field
  //           component={FormField}
  //           name="firstname"
  //           type="text"
  //           placeholder="Enter your firstname"
            
  //         />
  //          <Field
  //           component={FormField}
  //           name="firstname"
  //           type="text"
  //           placeholder="Enter your firstname"
  //           feedback={<span className="fa fa-envelope text-muted" />}
  //         />
  //          <Field
  //           component={FormField}
  //           name="firstname"
  //           type="text"
  //           placeholder="Enter your firstname"
  //           feedback={<span className="fa fa-envelope text-muted" />}
  //         />
  //         <Field
  //           component={FormField}
  //           name="email"
  //           type="email"
  //           placeholder="Enter email"
  //           feedback={<span className="fa fa-envelope text-muted" />}
  //         />
  //         <Field
  //           component={FormField}
  //           name="password"
  //           type="password"
  //           placeholder="Password"
  //           feedback={<span className="fa fa-lock text-muted" />}
  //         />
  //         <div className="clearfix">
  //           {/*<div className="checkbox c-checkbox pull-left mt0">
  //             <label>
  //               <input type="checkbox" value="" name="remember" />
  //               <em className="fa fa-check" />Remember Me
  //             </label>
  //           </div>*/}
  //           <div className="pull-right">
  //             <Link to="/forgot" className="text-muted">
  //               Forgot your password?
  //             </Link>
  //           </div>
  //         </div>
  //         <button type="submit" className="btn btn-block btn-primary mt-lg" disabled={submitting}>
  //           Register
  //         </button>
  //       </form>
  //     </div>
  //   </div>
  // </div>
//);

 UserRegistration.propTypes = {
  handleSubmit: func,
   submitting: bool,
 };

const mapStateToProps = () => ({
  // auth_error: state.auth.error,
  initialValues: {
    email: "",
    password: "",
  },
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => dispatch(signinWithPassword(values.email, values.password)),
});

const validate = combineValidators({
  email: composeValidators(isRequired({ message: "Email is required" }), isValidEmail)(),
  password: composeValidators(isRequired({ message: "Password is required" }))(),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: "login",
    validate: validate,
  })(UserRegistration),
);



// WEBPACK FOOTER //
// ./src/containers/UserRegistration.js